import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { ViewerRevenueCharge } from '../../../../../../core/models/api.models';
import {
  formatCurrency,
  formatHolderLabel,
  formatText,
  isChargeItem,
  parseAdditionalFields
} from '../../investor-viewer-format.utils';
import { InvestorViewerAccordionComponent } from '../investor-viewer-accordion/investor-viewer-accordion.component';

@Component({
  selector: 'dbw-investor-viewer-revenue-charges-section',
  imports: [InvestorViewerAccordionComponent],
  templateUrl: './investor-viewer-revenue-charges-section.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: '../../investor-viewer-section.shared.scss'
})
export class InvestorViewerRevenueChargesSectionComponent {
  readonly items = input.required<ViewerRevenueCharge[]>();

  readonly revenueItems = computed(() =>
    this.items().filter(item => !isChargeItem(item)));

  readonly chargeItems = computed(() =>
    this.items().filter(item => isChargeItem(item)));

  protected readonly formatText = formatText;
  protected readonly formatCurrency = formatCurrency;
  protected readonly formatHolderLabel = formatHolderLabel;
  protected readonly parseAdditionalFields = parseAdditionalFields;
}
